<script setup lang="ts">
import { useUnifiedPublicLoaderContext } from '~kui/composables/useUnifiedPublicLoaderContext';

import { useUnifiedPublicLoaderAnimation } from '~/composables/useUnifiedPublicLoaderAnimation';

const loaderCtx = useUnifiedPublicLoaderContext();
const loaderWrapperRef = ref<HTMLElement | null>(null);
const overlayRef = ref<HTMLElement | null>(null);
const logoRef = ref<HTMLElement | null>(null);

useUnifiedPublicLoaderAnimation(loaderWrapperRef, overlayRef, logoRef, loaderCtx);
</script>

<template>
  <div ref="loaderWrapperRef" class="fixed inset-0 z-[100] pointer-events-none">
    <!-- Lime circle — always round, zooms via scale -->
    <div
      ref="overlayRef"
      class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-24 h-24 rounded-full bg-secondary opacity-0 pointer-events-none blur-sm"
    />
    <!-- Logo: position: fixed, left/top set by GSAP to match header logo coordinates -->
    <div ref="logoRef" class="fixed opacity-0">
      <KUICoreIllustration
        illustration="anyway-logo-beta"
        class="fill-white h-10 lg:h-16 w-auto shrink-0"
        alt="Anyway"
      />
    </div>
  </div>
</template>
